import { defineComponent as _defineComponent } from 'vue'
import { reactive, computed, onMounted } from "vue";
  import useVuelidate from "@vuelidate/core";
  import { required } from "@vuelidate/validators";
  import store from "@/store";
  import router from "@/router";
  import { StageInterface } from "@/types/StageInterface";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminStageUpdate',
  setup(__props, { expose: __expose }) {
  __expose();

  const userId = router.currentRoute.value.params.userId;
  const estateId = router.currentRoute.value.params.estateId;
  const stageId = router.currentRoute.value.params.stageId;
  const form = reactive<Partial<StageInterface>>({
    title: "",
  });
  const rules = computed(() => {
    return {
      title: { required, $autoDirty: true },
    };
  });
  const v$ = useVuelidate(rules, form);

  onMounted(() => {
    store.dispatch("stage/getStage", stageId).then((res) => {
      form.title = res.data.title;
    });
  });

  async function updateStage() {
    v$.value.$touch();
    const isFormCorrect = await v$.value.$validate();

    if (!isFormCorrect) return;

    store
      .dispatch("stage/updateStage", {
        id: stageId,
        data: form,
      })
      .then(() => {
        router.push({
          name: "AdminEstate",
          params: { userId, estateId },
        });
      });
  }

const __returned__ = { userId, estateId, stageId, form, rules, v$, updateStage, reactive, computed, onMounted, get useVuelidate() { return useVuelidate }, get required() { return required }, get store() { return store }, get router() { return router }, get StageInterface() { return StageInterface } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})